// extracted by mini-css-extract-plugin
export const song_lyrics__mobile = "SongLyrics-module--song_lyrics__mobile--1AJbb";
export const song_lyrics__nav = "SongLyrics-module--song_lyrics__nav--2PhTw";
export const song_lyric_container = "SongLyrics-module--song_lyric_container--24qfY";
export const song_lyrics__desktop = "SongLyrics-module--song_lyrics__desktop--G3TdR";
export const song_lyrics = "SongLyrics-module--song_lyrics--2W-BI";
export const song_lyrics__nav_options = "SongLyrics-module--song_lyrics__nav_options--1qDAx";
export const song_lyric = "SongLyrics-module--song_lyric--rXsW8";